import { ConfirmationIcon } from '@icons';

import { ConfirmationModal } from '@components';
import CurrencyAmount from '@components/currency-amount/CurrencyAmount';

type MarkAsPaidConfirmationModalProps = {
  amount: number | string;
  payerName: string;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const MarkAsPaidConfirmationModal = ({
  amount,
  payerName,
  isLoading,
  onConfirm,
  onCancel
}: MarkAsPaidConfirmationModalProps) => (
  <ConfirmationModal
    isOpen
    className="w-118 !bg-white !pb-6"
    title="Confirmation"
    titleStyle="!font-semibold !mb-2"
    message={
      <div>
        Are you sure you want to mark this payment of{' '}
        <span className="inline-flex items-baseline">
          <CurrencyAmount
            value={amount}
            className="gap-0.5 font-semibold"
            symbolClass="!text-[0.975rem]"
          />
        </span>{' '}
        from <span className="font-semibold">{payerName}</span> as paid?
      </div>
    }
    messageStyle="!text-base !mb-8 !max-w-[400px] !mx-auto"
    handleConfirm={onConfirm}
    handleCancel={onCancel}
    primaryButtonVariant="primary"
    secondaryButtonVariant="tertiary"
    primaryButtonSize="medium"
    confirmButtonStyle="!py-2 !text-base !font-medium"
    secondaryButtonSize="medium"
    cancelButtonStyle="bg-transparent !text-base !font-medium"
    isConfirmButtonLoading={isLoading}
    ModalIcon={ConfirmationIcon}
    customModalIconStyle="!w-12 !h-12 !min-w-12 !min-h-12"
    isClickOutsideRequired={false}
    confirmButtonLabelStyle="!text-base !font-medium"
    cancelButtonLabelStyle="!text-base !font-medium"
  />
);

export default MarkAsPaidConfirmationModal;
